import {
  emailSchema,
  emailUI,
  internationalPhoneSchema,
  internationalPhoneUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['contact-title']),
    email: emailUI(),
    primaryPhone: internationalPhoneUI(content['contact-phone-label']),
  },
  schema: {
    type: 'object',
    required: ['email', 'primaryPhone'],
    properties: {
      email: emailSchema,
      primaryPhone: internationalPhoneSchema({ required: true }),
    },
  },
};
